export default {
  "AgreementCardPersonalRelation.CardName":
    "個人関連情報の個人データとしての{linebreak}取得・利用",
  "AgreementCardPersonalRelation.CardDetail":
    "「個人関連情報{asterisk1}」をドコモおよびドコモフィナンシャルグループが他社から受領し、ドコモが保有するお客さまの情報と合わせて利用させていただきます",
  "AgreementCardPersonalRelation.CardDetail2":
    "例：提供元ではお客さまを特定できないサイト閲覧履歴、TV視聴履歴等",
  "AgreementCardPersonalRelation.CardDetail3":
    "同意状況は、ドコモおよびドコモフィナンシャルグループで共通して適用されます",
}
